module.exports = __webpack_public_path__ + "img/source-code-pro-v22-latin-600.28467c29.svg";